import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Select } from "@ngxs/store";
import { DialogContentBase, DialogRef } from "@progress/kendo-angular-dialog";
import { ActionService } from "app/intake/actions/action-service";
import { IntakeService } from "app/intake/intake-services/intake.service";
import { IntakeState } from "app/_state/intake.state";
import { CedNotificationService } from "ced-ng-library";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-dossier-action-details',
    templateUrl: './dossier-actions.component.html'
})


export class DossierActionsComponent extends DialogContentBase implements OnInit, OnDestroy {

    dataSource: any[] = [];
    @Select(IntakeState.getIntake) getIntake$: Observable<any>;
    private _subject$: Subject<boolean> = new Subject();
    selectedAction: any;
    constructor(dialog: DialogRef,
        private actionService: ActionService,
        private intakeService: IntakeService,
        private cd: ChangeDetectorRef,
        private translateService: TranslateService,
        private cedNotificationService: CedNotificationService
    ) {
        super(dialog);
    }
    ngOnInit(): void {
        this.getActions();
    }

    onCellClick($event) {
        this.selectedAction = $event.dataItem
    }

    dblClickEvent() {
        this.dialog.close(this.selectedAction);
    }

    getActions() {
        this.dataSource = [];
        this.getIntake$.pipe(takeUntil(this._subject$)).subscribe((result) => {
            if (result.intake.dossierId != null) {
                this.actionService
                    .getActionsByDossierId(result.intake.dossierId)
                    .pipe(takeUntil(this._subject$))
                    .subscribe((data: any) => {
                        if ((data != null) || (data != undefined) || (data != "")) {
                            let actionsList = [];
                            data.forEach(element => {
                                try {
                                    if(element.doaIsUrgent){
                                        element.doaIsUrgent = this.translateService.instant('YES')
                                    }else{
                                        element.doaIsUrgent = this.translateService.instant('NO')
                                    }
                                    element.daoFollowUpDate = this.getDate(element.doaFollowUpDate);
                                    element.doaClosedDateAndTime = this.getDate(element.doaClosedDateAndTime);
                                    element.doaCreatedDate = this.getDate(element.doaCreatedDate);
                                    element.doaLastModifiedDate = this.getDate(element.doaLastModifiedDate);
                                    actionsList.push(element);
                                }
                                catch (e) {
                                }

                            });
                            this.dataSource = [...actionsList];
                        }
                        this.cd.detectChanges();
                    },
                    (error) => {
                      this.cedNotificationService.error("NOTIFICATIONS.GET_ACTIONS");
                    });
            }
        });
    }

    getDate(date) {
        return this.getLocaleDate(date);
    }

    getLocaleDate(date: Date) {
        if (date != null && (this.isIsoDate(date.toString()) || date.toString().indexOf('GMT') == -1)) {
            return this.intakeService.getLocalDate(date);
        }
        return date;
    }

    isIsoDate(dateStringToCompare) {
        return new Date(dateStringToCompare).toISOString() === dateStringToCompare;
    }

    selectAction() {
        this.dialog.close();
    }

    cancel() {
        this.dialog.close();
    }

    ngOnDestroy(): void {
        this._subject$.next();
        this._subject$.complete();
    }
}